import { IAuditEvent } from '../hooks/reactQuerys/AuditQueries';

/**
 * Die Einladungsrechte, die ein Vorgang beim Anlegen aus seiner
 * Rechtsgeschäftsart bekommt (#1330).
 *
 * Jedes einzelne Recht erzeugte eine eigene Zeile — bei einer gewöhnlichen
 * Rechtsgeschäftsart elf Stück untereinander, für eine Handlung, die niemand
 * einzeln entschieden hat. Sie stehen jetzt als Liste im `Metadata` des
 * Sammeleintrags und klappen erst auf Klick auf.
 */
export const INVITE_RIGHTS_CREATED = 'legal_transaction.invite_rights_created';

/**
 * Liest die Rechte als lesbare Sätze.
 *
 * Defensiv, weil `Metadata` als JSON in der Datenbank liegt: ein alter oder
 * unerwarteter Inhalt darf die Protokollansicht nicht zerlegen. Fehlt ein
 * Rollenname — etwa weil die Vorlage ihn nicht mitgab —, entfällt der
 * Eintrag, statt „undefined → Notar" anzuzeigen.
 */
export const inviteRightItems = (event: IAuditEvent): string[] => {
  const raw = (event.Metadata ?? {})['items'];
  if (!Array.isArray(raw)) return [];

  return raw
    .filter(
      (entry): entry is Record<string, unknown> =>
        typeof entry === 'object' && entry !== null
    )
    .map(entry => ({
      von: typeof entry.from === 'string' ? entry.from : '',
      nach: typeof entry.to === 'string' ? entry.to : '',
    }))
    .filter(paar => paar.von !== '' && paar.nach !== '')
    .map(paar => `„${paar.von}“ darf „${paar.nach}“ einladen`);
};

/** true, wenn die Vorlage zu viele Rechte hatte und die Liste gekappt wurde. */
export const inviteRightsTruncated = (event: IAuditEvent): boolean =>
  (event.Metadata ?? {})['truncated'] === true;
